export default __webpack_public_path__ + "static/media/1.b8251da9.png";